import { useEffect, useState } from 'react'

const useWindowHash = () => {
	const [hash, setHash] = useState(typeof window !== 'undefined' ? window?.location?.hash?.substring(1) : undefined)

	useEffect(() => {
		const handleHashChange = () => {
			const newHash = window?.location?.hash?.substring(1)
			setHash(newHash)
		}

		handleHashChange()

		window.addEventListener('hashchange', handleHashChange)

		return () => {
			window.removeEventListener('hashchange', handleHashChange)
		}
	}, [])

	return hash
}

export default useWindowHash
